import { combineReducers } from 'redux'
import view from './viewReducer'
import token from './tokenReducer'
import showSmallBox from './eventsReducer'
import seenOverlayers from './seenOverlayers'
import showDisabilitySuccess from './disabilityReducer'
import articleRatings from './articleRatings'
import visits from './visitsReducer'
import email from './emailReducer'

export default combineReducers({
  view,
  token,
  showSmallBox,
  showDisabilitySuccess,
  email,
  seenOverlayers,
  articleRatings,
  visits,
})
